
// import mammoth from 'mammoth'
import { getDictGroups } from '@/api/system/system'
import { isObject } from './is'
/**
 * 将字典接口dictValue换成汉字
 * @param {*} value 接口返回值
 * @param {*} type 字典的type
 * @param {*} list 字典集合
 * @returns
 */
export function formatDictToText (value, type, list) {
  if((!(value && list)) || !(list[type] && list[type].length) ){
    return ''
  }
  let keyValueText = ''
  let keyValueTextArr = []
  let dictList = list[type]

  if(!isObject(value)){ 
    value = String(value).split(",")
  }
  value.map(d=>{
    let existObj = dictList.find(item=>item.dictValue == d)
    if(existObj) keyValueTextArr.push(existObj.dictLabel)
  })
  keyValueText = keyValueTextArr && keyValueTextArr.join(', ')
  return keyValueText || ''
}

/**
 * 数组去重
 * @param {*} local 例：广东省,江门市,新会区,会城街道办,梅江村委会,塞口围
 * @param {*} sliceIndex 切除个数
 * @returns
 */
export function formatLocal(local, sliceIndex){
  if(!local){
    return ''
  }
  let localJson = ''
  if(local.indexOf('undefined') > -1 || local.indexOf('null') > -1){
    localJson = local.split(',')
  }else{
    localJson = local.split(',').slice(sliceIndex)
  }
  let str = localJson.join('').replace(/undefined|null/g, '');
  return str
}
/**
 * 数组去重
 * @param {*} arr 数组
 * @param {*} key key属性
 * @returns 去重后的数组
 */
export function uniqueArr (arr, key) {
  let obj = {}
  arr = arr.reduce((newArr, next) => {
    if (!next) return
    obj[next[key]] ? '' : (obj[next[key]] = true && newArr.push(next))
    return newArr
  }, [])
  return arr
}

export function uniqueArr2 (arr) {
  return Array.from(new Set(arr))
}

export function uniqueArr3 (arr, key1, key2) {
  let obj = {}
  arr = arr.reduce((newArr, next) => {
    if (!next) return
    obj[next[key1]] && obj[next[key2]] ? '' : (obj[next[key1]] = obj[next[key2]] = true && newArr.push(next))
    return newArr
  }, [])
  return arr
}

export function assignArr (selectArr, arr, key) {
  let ids = [];
  if (selectArr.length > 0) {
    ids.push(...selectArr.map((item) => item[key]))
  }
  let newArr = { ...arr, pageNum: null, pageSize: null, ids: ids }
  return newArr
}

export function sumArr (arr, key) {
  let sum = arr.reduce((accumulator, currentValue) => {
    let newCurrentValue = currentValue[key] ? currentValue[key] : 0
    let sum = Number(accumulator) + Number(newCurrentValue)
    return myFixed(sum, 2)
  }, 0)

  return sum
}


/**
 * 通用js方法封装处理
 * Copyright (c) 2019 ruoyi\
 */


// 日期格式化
export function parseTime (time, pattern, sliceArr) {
  if (arguments.length === 0 || !time) {
    return null
  }
  const format = pattern || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if (typeof time === 'string' && /^[0-9]+$/.test(time)) {
      time = parseInt(time)
    } else if (typeof time === 'string') {
      time = time
        .replace(new RegExp(/-/gm), '/')
        .replace('T', ' ')
        .replace(new RegExp(/\.[\d]{3}/gm), '')
    }
    if (typeof time === 'number' && time.toString().length === 10) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay(),
  }
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') {
      return ['日', '一', '二', '三', '四', '五', '六'][value]
    }
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })

  if(sliceArr){
    const time_slice_str = time_str.slice(sliceArr[0], sliceArr[1])
    return time_slice_str
  }
  return time_str
}

// 获取当前日期
export function getNowFormatDate (type) {
  let date = new Date(),
    year = date.getFullYear(), //获取完整的年份(4位)
    month = date.getMonth() + 1, //获取当前月份(0-11,0代表1月)
    strDate = date.getDate() // 获取当前日(1-31)
  if (month >= 1 && month <= 9) month = '0' + month // 如果月份是个位数，在前面补0
  if (strDate >= 0 && strDate <= 9) strDate = '0' + strDate // 如果日是个位数，在前面补0
  let currentdate = ''
  if (type) {
    currentdate = `${year}-${month}-${strDate}`
  } else {
    currentdate = `${year} 年 ${month} 月 ${strDate} 日`
  }
  return currentdate
}

// 根据键名获取键值
export function formatJson (filterVal, list) {
  return list.map((v, index) =>
    filterVal.map((j) => {
      if (j == 'index') {
        return (v[j] = index + 1)
      } else {
        return typeof v[j] == 'number' ? v[j] || 0 : v[j] || ''
      }
    })
  )
}

// 表单重置

export function resetField (refName, refFieldName) {
  if (this.$refs[refName]) {
    this.$refs[refName].clearValidate(refFieldName)
  }
}
export function resetForm (refName) {
  if (this.$refs[refName]) {
    this.$refs[refName].resetFields()
  }
}

// 添加日期范围
export function addDateRange (params, dateRange, propName) {
  let search = params
  dateRange = Array.isArray(dateRange) ? dateRange : []
  if (typeof propName === 'undefined') {
    search['startTime'] = dateRange[0]
    search['endTime'] = dateRange[1]
  } else {
    search['start' + propName] = dateRange[0]
    search['end' + propName] = dateRange[1]
  }
  return search
}

// 回显数据字典
export function selectDictLabel (datas, value) {
  if (value === undefined) {
    return ''
  }
  var actions = []
  Object.keys(datas).some((key) => {
    if (datas[key].value == '' + value) {
      actions.push(datas[key].label)
      return true
    }
  })
  if (actions.length === 0) {
    actions.push(value)
  }
  return actions.join('')
}

// 回显数据字典（字符串数组）
export function selectDictLabels (datas, value, separator) {
  if (value === undefined) {
    return ''
  }
  var actions = []
  var currentSeparator = undefined === separator ? ',' : separator
  var temp = value.split(currentSeparator)
  Object.keys(value.split(currentSeparator)).some((val) => {
    var match = false
    Object.keys(datas).some((key) => {
      if (datas[key].value == '' + temp[val]) {
        actions.push(datas[key].label + currentSeparator)
        match = true
      }
    })
    if (!match) {
      actions.push(temp[val] + currentSeparator)
    }
  })
  return actions.join('').substring(0, actions.join('').length - 1)
}

// 字符串格式化(%s )
export function sprintf (str) {
  var args = arguments,
    flag = true,
    i = 1
  str = str.replace(/%s/g, function () {
    var arg = args[i++]
    if (typeof arg === 'undefined') {
      flag = false
      return ''
    }
    return arg
  })
  return flag ? str : ''
}

// 转换字符串，undefined,null等转化为""
export function parseStrEmpty (str) {
  if (!str || str == 'undefined' || str == 'null') {
    return '-'
  }
  return str
}

// 数据合并
export function mergeRecursive (source, target) {
  for (var p in target) {
    try {
      if (target[p].constructor == Object) {
        source[p] = mergeRecursive(source[p], target[p])
      } else {
        source[p] = target[p]
      }
    } catch (e) {
      source[p] = target[p]
    }
  }
  return source
}

/**
 * 构造树型结构数据
 * @param {*} data 数据源
 * @param {*} id id字段 默认 'id'
 * @param {*} parentId 父节点字段 默认 'parentId'
 * @param {*} children 孩子节点字段 默认 'children'
 */
export function handleTree (data, id, parentId, children) {
  let config = {
    id: id || 'id',
    parentId: parentId || 'parentId',
    childrenList: children || 'children',
  }

  var childrenListMap = {}
  var nodeIds = {}
  var tree = []

  for (let d of data) {
    let parentId = d[config.parentId]
    if (childrenListMap[parentId] == null) {
      childrenListMap[parentId] = []
    }
    nodeIds[d[config.id]] = d
    childrenListMap[parentId].push(d)
  }

  for (let d of data) {
    let parentId = d[config.parentId]
    if (nodeIds[parentId] == null) {
      tree.push(d)
    }
  }

  for (let t of tree) {
    adaptToChildrenList(t)
  }

  function adaptToChildrenList (o) {
    if (childrenListMap[o[config.id]] !== null) {
      o[config.childrenList] = childrenListMap[o[config.id]]
    }
    if (o[config.childrenList]) {
      for (let c of o[config.childrenList]) {
        adaptToChildrenList(c)
      }
    }
  }
  return tree
}

/**
 * 参数处理
 * @param {*} params  参数
 */
export function tansParams (params) {
  let result = ''
  for (const propName of Object.keys(params)) {
    let value = params[propName]
    /* 添加过滤所有get请求String类型参数前后空格  */
    value = typeof value == 'string' ? value.trim() : value
    var part = encodeURIComponent(propName) + '='
    if (value !== null && typeof value !== 'undefined') {
      if (typeof value === 'object') {
        for (const key of Object.keys(value)) {
          if (value[key] !== null && typeof value[key] !== 'undefined') {
            let params = propName + '[' + key + ']'
            var subPart = encodeURIComponent(params) + '='
            result += subPart + encodeURIComponent(value[key]) + '&'
          }
        }
      } else {
        result += part + encodeURIComponent(value) + '&'
      }
    }
  }
  return result
}

// 验证是否为blob格式
export async function blobValidate (data) {
  try {
    const text = await data.text()
    JSON.parse(text)
    return false
  } catch (error) {
    return true
  }
}

export function convertCurrency (money) {
  //汉字的数字
  var cnNums = new Array('零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖')
  //基本单位
  var cnIntRadice = new Array('', '拾', '佰', '仟')
  //对应整数部分扩展单位
  var cnIntUnits = new Array('', '万', '亿', '兆')
  //对应小数部分单位
  var cnDecUnits = new Array('角', '分', '毫', '厘')
  //整数金额时后面跟的字符
  var cnInteger = '整'
  //整型完以后的单位
  var cnIntLast = '圆'
  //最大处理的数字
  var maxNum = 999999999999999.9999
  //金额整数部分
  var integerNum
  //金额小数部分
  var decimalNum
  //输出的中文金额字符串
  var chineseStr = ''
  //分离金额后用的数组，预定义
  var parts
  // 传入的参数为空情况
  if (money == '') {
    return ''
  }
  money = parseFloat(money)
  if (money >= maxNum) {
    return ''
  }
  // 传入的参数为0情况
  if (money == 0) {
    // chineseStr = cnNums[0] + cnIntLast + cnInteger;
    chineseStr = cnNums[0]
    return chineseStr
  }
  // 转为字符串
  money = money.toString()
  // indexOf 检测某字符在字符串中首次出现的位置 返回索引值（从0 开始） -1 代表无
  if (money.indexOf('.') == -1) {
    integerNum = money
    decimalNum = ''
  } else {
    parts = money.split('.')
    integerNum = parts[0]
    decimalNum = parts[1].substr(0, 4)
  }
  //转换整数部分
  if (parseInt(integerNum, 10) > 0) {
    let zeroCount = 0
    let IntLen = integerNum.length
    for (let i = 0; i < IntLen; i++) {
      let n = integerNum.substr(i, 1)
      let p = IntLen - i - 1
      let q = p / 4
      let m = p % 4
      if (n == '0') {
        zeroCount++
      } else {
        if (zeroCount > 0) {
          chineseStr += cnNums[0]
        }
        zeroCount = 0
        chineseStr += cnNums[parseInt(n)] + cnIntRadice[m]
      }
      if (m == 0 && zeroCount < 4) {
        chineseStr += cnIntUnits[q]
      }
    }
    // 最后+ 元
    chineseStr += cnIntLast
  }
  // 转换小数部分
  if (decimalNum != '') {
    let decLen = decimalNum.length
    for (let i = 0; i < decLen; i++) {
      let n = decimalNum.substr(i, 1)
      if (n != '0') {
        chineseStr += cnNums[Number(n)] + cnDecUnits[i]
      } else if (n == '0' && i == 0) {
        chineseStr += cnNums[Number(n)]
      }
    }
  }
  if (chineseStr == '') {
    // chineseStr += cnNums[0] + cnIntLast + cnInteger;
    chineseStr += cnNums[0]
  } else if (decimalNum == '') {
    // chineseStr += cnInteger;
  }
  if (chineseStr.indexOf('角') != -1 || chineseStr.indexOf('分') != -1) {
    return chineseStr
  } else {
    return chineseStr + '整'
  }
}

// 废弃
export function newConvertCurrency (n) {
  if (n === void 0 || isNaN(n)) {
    return ''
  }
  const fraction = ['角', '分', '厘']
  const digit = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖']
  const unit = [
    ['圆', '万', '亿'],
    ['', '拾', '佰', '仟'],
  ]
  const head = n < 0 ? '欠' : ''
  n = Math.abs(n)
  let s = ''
  for (let i = 0; i < fraction.length; i++) {
    s += (digit[Math.floor(multiply(multiply(n, 10), Math.pow(10, i))) % 10] + fraction[i]).replace(/零./, '')
  }
  s = s || '整'
  n = Math.floor(n)
  for (let i = 0; i < unit[0].length && n > 0; i++) {
    let p = ''
    for (let j = 0; j < unit[1].length && n > 0; j++) {
      p = digit[n % 10] + unit[1][j] + p
      n = Math.floor(n / 10)
    }
    s = p.replace(/(零.)*零$/, '').replace(/^$/, '零') + unit[0][i] + s
  }
  return (
    head +
    s
      .replace(/(零.)*零圆/, '圆')
      .replace(/(零.)+/g, '零')
      .replace(/^整$/, '零圆整')
  )
}
// 将一个数字按照指定精度进行四舍五入
export function myFixed (number, precision) {
  return Math.round(+number + "e" + precision) / Math.pow(10, precision);
}
/**
 * 数学乘法计算
 * @argument {number} arguments 可传入多个参数，如：multiply(1,2,3,...)
 * @return {number} 返回多个数相乘的结果
 */
export function multiply () {
  let result = 1
  let n1, n2
  let r1, r2 // 小数位数
  for (let i = 0; i < arguments.length; i++) {
    const arg1 = toNonExponential(result)
    const arg2 = toNonExponential(arguments[i])
    try {
      r1 = arg1.toString().split('.')[1].length
    } catch (e) {
      r1 = 0
    }
    try {
      r2 = arg2.toString().split('.')[1].length
    } catch (e) {
      r2 = 0
    }
    n1 = Number(arg1.toString().replace('.', ''))
    n2 = Number(arg2.toString().replace('.', ''))
    result = (n1 * n2) / Math.pow(10, r1 + r2)
  }
  return result
}

/**
 * 将科学计数法的数字转为字符串
 * 说明：运算精度丢失方法中处理数字的时候，如果出现科学计数法，就会导致结果出错
 * 4.496794759834739e-9  ==> 0.000000004496794759834739
 * 4.496794759834739e+9  ==> 4496794759.834739
 * @param  num
 * @return {number} 返回处理后结果
 */
export function toNonExponential (num) {
  if (num == null) {
    return num
  }
  if (typeof num === 'number') {
    const m = num.toExponential().match(/\d(?:\.(\d*))?e([+-]\d+)/)
    return Number(num.toFixed(Math.max(0, (m[1] || '').length - m[2])))
  } else {
    return num
  }
}

/**
 * 列表根据键名去重
 * @arr 对象数组
 * @keyName 键名
 * */
export function setListByKey (arr, keyName) {
  let obj = {}
  arr = arr.reduce((newArr, next) => {
    obj[next[keyName]] ? '' : (obj[next[keyName]] = true && newArr.push(next))
    return newArr
  }, [])
  return arr
}

/**
 * 千分符
 *  @author ksy
 *  @createdTime 2022.8.12
 *  @lastModifiedTime 最后更改时间
 * */
export function currency (intStr) {
  let str = intStr.toString().split('').reverse().join('')

  let str1 = str.replace(/(\d{3})(?=\d)/g, '$1,')

  let str2 = str1.split('').reverse().join('')

  return str2
}

// 图片上传限制
export function beforeImageUpload (file) {
  const isJPG =
    file.type === 'image/jpeg' ||
    file.type === 'image/png' ||
    file.type === 'image/webp' ||
    file.type === 'image/gif'

  if (!isJPG) {
    this.$message.error('文件只能是 jpg/png/webp/gif 格式')
  }
  return isJPG
}
// 文件上传限制
export function beforeFileUpload (file) {
  const fileSuffix = file.name.substring(file.name.lastIndexOf('.') + 1)
  const whiteList = [
    'jpg',
    'png',
    'jpeg',
    'webp',
    'gif',
    'bmp',
    'pdf',
    'dwg',
    'dxf',
    'xls',
    'xlsx',
    'doc',
    'docx',
    'txt',
    'mp4',
    'avi',
  ]

  let photoType = ['jpg', 'png', 'jpeg', 'webp', 'gif', 'bmp']
  let fileType = ['pdf', 'dwg', 'dxf', 'xls', 'xlsx', 'doc', 'docx', 'txt']
  let viewType = ['mp4', 'avi']

  const isFileType = whiteList.indexOf(fileSuffix.toLowerCase()) > -1
  let isLt5M,
    big = 20,
    type = '文件'
  if (photoType.includes(fileSuffix.toLowerCase())) {
    isLt5M = file.size / 1024 / 1024 < 10
    big = 10
    type = '图片'
  } else if (fileType.includes(fileSuffix.toLowerCase())) {
    isLt5M = file.size / 1024 / 1024 < 20
    big = 20
    type = '文件'
  } else if (viewType.includes(fileSuffix.toLowerCase())) {
    isLt5M = file.size / 1024 / 1024 < 50
    big = 50
    type = '视频'
  }

  if (!isFileType) {
    this.$message.error('文件只能是 JPG/PNG/JPEG/WEBP/GIF/BMP/PDF/DWG/DXF/XLS/XLSX/DOC/DOCX/TXT/MP4/AVI 格式!')
  }
  if (!isLt5M) {
    this.$message.error(type + '大小不能超过 ' + big + 'MB!')
  }
  return isFileType && isLt5M
}

// 获取文件类型
export function fileInfo (file) {
  //附件类型（0-图片、1-视频、2-文件）
  const suffix = file.name.substring(file.name.lastIndexOf('.') + 1)
  const name = file.name
  const url = file.url
  let photoType = ['jpg', 'png', 'jpeg', 'webp', 'gif', 'bmp']
  let fileType = ['pdf', 'dwg', 'dxf', 'xls', 'xlsx', 'doc', 'docx', 'txt']
  let viewType = ['mp4', 'avi']
  let type = 2
  if (photoType.includes(suffix.toLowerCase())) {
    type = 0
  } else if (fileType.includes(suffix.toLowerCase())) {
    type = 2
  } else if (viewType.includes(suffix.toLowerCase())) {
    type = 1
  }
  return {
    name,
    type,
    url,
    suffix
  }
}


// 金额千分符格式化
export function formatMoney (money) {
  if (isNaN(money)) {
    money = 0
  }
  // console.log('money', 'type: ', typeof money, money)
  let num
  // 获取连续数字，如果有小数点则之后的不获取
  if (money) {
    num = Number(money)
      .toFixed(2)
      .replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
  } else {
    num = 0
  }
  return num
}
export function formatPrice (num) {
  if ((num || num == 0) && typeof Number(num) == 'number' && !isNaN(Number(num))) {
    num = Number(num)
    num = num + '' //数字转字符串
    let str = '' //字符串累加
    //判断是否有负号
    let isMinus = num.indexOf('-') != -1
    if (isMinus) num = num.split('-')[1]
    let result = num.indexOf('.') //判断是否有小数点
    if (result != -1) {
      // console.log('含有小数');
      let sum = num.split('.') //sum[0]小数点前面部分;sum[1]为小数部分
      for (let i = sum[0].length - 1, j = 1; i >= 0; i--, j++) {
        // const isDivide = sum[0].indexOf('-') > -1 ? j % 4 == 0 : j % 3 == 0 //判断是否是负数，是则每隔四位加逗号
        const isDivide = j % 3 == 0
        if (isDivide && i != 0) {
          //每隔三位加逗号，过滤正好在第一个数字的情况
          str += sum[0][i] + ',' //加千分位逗号
          continue
        }
        str += sum[0][i] //倒着累加数字
      }
      return isMinus ? '-' + str.split('').reverse().join('') + '.' + sum[1] : str.split('').reverse().join('') + '.' + sum[1]
    } else {
      // console.log('没有小数');
      for (let i = num.length - 1, j = 1; i >= 0; i--, j++) {
        // const isDivide = num.indexOf('-') > -1 ? j % 4 == 0 : j % 3 == 0 //判断是否是负数，是则每隔四位加逗号
        const isDivide = j % 3 == 0
        if (isDivide && i != 0) {
          //每隔三位加逗号，过滤正好在第一个数字的情况
          str += num[i] + ',' //加千分位逗号
          continue
        }
        str += num[i] //倒着累加数字
      }
      return str.split('').reverse().join('') //字符串=>数组=>反转=>字符串
    }
  } else {
    return num
  }
}

/**
 *  保留两位小数，不足两位补0
 *  @author ksy
 *  @createdTime 2022.9.7
 *  @lastModifiedTime 最后更改时间
 * */
export function fomatFloat (num, n) {
  var f = parseFloat(num)
  if (isNaN(f)) {
    return false
  }
  f = Math.round(num * Math.pow(10, n)) / Math.pow(10, n) // n 幂
  var s = f.toString()
  var rs = s.indexOf('.')
  //判定如果是整数，增加小数点再补0
  if (rs < 0) {
    rs = s.length
    s += '.'
  }
  while (s.length <= rs + n) {
    s += '0'
  }
  return s
}

/**
 * 扁平化对象数组
 * @author ksy
 * @createdTime 2022.9.7
 * @param {Array} arr  要扁平化的数组
 * @param {String} key 根据哪个属性进行扁平化
 */
export function flatten (arr, key) {
  const res = [] // 结果数组
  arr.forEach((item) => {
    if (item[key]) {
      res.push(item, ...flatten(item[key], key)) // 递归
    } else {
      res.push(item)
    }
  })
  return res
}

/**
 * 根据相同的数据进行分组
 * @author ksy
 * @createdTime 2022.9.7
 * @param {Array} arr  要分组的数组
 * @param {String} key 根据哪个属性进行分组
 */
function sortClass (sortData, key) {
  const groupBy = (array, f) => {
    let groups = {}
    array.forEach((o) => {
      let group = JSON.stringify(f(o))
      groups[group] = groups[group] || []
      groups[group].push(o)
    })
    return Object.keys(groups).map((group, index) => {
      return { title: JSON.parse(group), list: groups[group] }
    })
  }

  const sorted = groupBy(sortData, (item) => {
    return item[key] ? item[key].toString().trim().split(' ')[0] : '' // 返回需要分组的对象
  })
  return sorted
}

/**
 * 根据相同的数据进行分组
 * @author ksy
 * @createdTime 2022.9.7
 * @param {Array} arr  要分组的数组
 * @param {String} key 根据哪个属性进行分组
 */
export function groupClassByKey (data, key) {
  if(data && key){
    return sortClass(data, key)
  }
  return []
}

/**
 * 根据时间判断 对象数组 -- 今天/昨天/时间
 * @author ksy
 * @createdTime 2022.9.8
 * @param {Array} arr  要判断的数组
 * @param {String} time 根据时间属性进行判断
 * @param {String} sort 根据时间/名称首字母降序--desc、升序--asc
 */
export function recentlyTime (arr, time, sort) {
  let res = [] // 结果数组
  let l = 0

  //昨天的时间
  let day = new Date()
  day.setDate(day.getDate() - 1)
  let yesterday = parseTime(day, '{y}-{m}-{d}')

  //前天的时间
  // var day2 = new Date();
  // day2.setDate(day2.getDate() - 2);
  // var s2 = day2.format("yyyy-MM-dd");

  let todayList = [],
    yesterdayList = [],
    timeList = []

  arr.forEach((item, index) => {
    let date = item[time] ? item[time].toString().trim().split(' ')[0] : ''
    let todayDate = parseTime(new Date().getTime(), '{y}-{m}-{d}')
    if (date != todayDate && date != yesterday) {
      timeList.push(item)
    } else if (date == todayDate) {
      // 今天
      todayList.push(item)
      res[sort == 'desc' || !sort ? 0 : 1] = {
        title: '今天',
        list: todayList,
      }
    } else if (date == yesterday) {
      // 昨天
      yesterdayList.push(item)
      res[sort == 'desc' || !sort ? (res[0] ? 1 : 0) : 0] = {
        title: '昨天',
        list: yesterdayList,
      }
    }
  })

  timeList = sortClass(timeList, time).sort((a, b) => {
    return sort == 'desc' || !sort ? b.title.localeCompare(a.title) : a.title.localeCompare(b.title)
  })
  res = sort == 'desc' || !sort ? [...res, ...timeList] : [...timeList, ...res]
  let list = []
  res.forEach(function (item, i) {
    item.cardList = item.list
    list.push(item)
  })
  return list
}

/**
 * 判断n分钟前/n小时前...
 * @author ksy
 * @createdTime 2022.9.8
 * @param {Array} arr  要判断的数组
 * @param {String} stringTime 时间
 */
export function friendlyFormatTime (stringTime) {
  let str = stringTime
  //将字符串转换成时间格式
  let timePublish = new Date(str)
  let timeNow = new Date()
  let minute = 1000 * 60
  let hour = minute * 60
  let day = hour * 24
  let month = day * 30
  let year = month * 12
  let diffValue = timeNow - timePublish
  let diffMonth = diffValue / month
  let diffWeek = diffValue / (7 * day)
  let diffDay = diffValue / day
  let diffHour = diffValue / hour
  let diffMinute = diffValue / minute
  let diffYear = diffValue / year
  let result = null
  if (diffValue < 0) {
    result = '刚刚'
  } else if (diffYear > 1) {
    result = parseInt(diffYear) + '年前'
  } else if (diffMonth > 1) {
    result = parseInt(diffMonth) + '月前'
  } else if (diffWeek > 1) {
    result = parseInt(diffWeek) + '周前'
  } else if (diffDay > 1) {
    result = parseInt(diffDay) + '天前'
  } else if (diffHour > 1) {
    result = parseInt(diffHour) + '小时前'
  } else if (diffMinute > 1) {
    result = parseInt(diffMinute) + '分钟前'
  } else {
    result = '刚刚'
  }
  return result
}

/**
 * 生成UUID
 * @author ksy
 * @createdTime 2022.9.15
 */
export function uuid () {
  var s = []
  var hexDigits = '0123456789abcdef'
  for (var i = 0; i < 36; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1)
  }
  s[14] = '4' // bits 12-15 of the time_hi_and_version field to 0010
  s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1) // bits 6-7 of the clock_seq_hi_and_reserved to 01
  s[8] = s[13] = s[18] = s[23] = '-'

  var uuid = s.join('')
  return uuid
}

/**
 * 附件在线查看
 * @author ksy
 * @createdTime 2022.9.28
 */
export async function fileShow (row) {
  let phototypeList = ['pdf', 'txt', 'jpg', 'png', 'jpeg', 'webp', 'gif', 'bmp']
  if (phototypeList.includes(row.fileSuffix.toLowerCase())) {
    let url = 'http://39.108.128.129:9999'
    let res = await getDictGroups({ types: 'interfaceServiceIp' })
    if (res.code == 200 && res.flag) {
      let row = res.data.interfaceServiceIp && res.data.interfaceServiceIp.length ? res.data.interfaceServiceIp[0] : null
      if (row) {
        url = 'http://' + row.dictValue + ':9999'
      }
    }
    window.open(url + '/file/show?fileUrl=' + row.fileUrl)
  } else if (
    ['xls', 'xlsx'].includes(row.fileSuffix.toLowerCase())
  ) {
    let url = 'https://view.officeapps.live.com/op/view.aspx?src='
    window.open(url + row.fileUrl)
  } else if (['docx'].includes(row.fileSuffix.toLowerCase())) {
    // viewDoc(row.fileUrl);
  } else if (['doc'].includes(row.fileSuffix.toLowerCase())) {
    // this.$message.warning('暂不支持该格式预览！');
    if (['txt'].includes(row.fileSuffix.toLowerCase())) {
      this.$message.warning('该文件不支持在线预览，已为你自动下载')
      window.location.href = row.fileUrl
      return
    }
    this.$message.warning('该文件不支持在线预览，已为你自动下载')
    window.location.href = row.fileUrl
  } else if (['dwg', 'dxf'].includes(row.fileSuffix.toLowerCase())) {
    this.$message.warning('该文件不支持在线预览，已为你自动下载')
    window.location.href = row.fileUrl
  } else {
    this.$message.warning('该文件不支持在线预览，已为你自动下载')
    window.location.href = row.fileUrl
  }
}

/**
 * 预览doc文件
 * @author ksy
 * @createdTime 2022.9.28
 */
// function viewDoc (file) {
//   const xhr = new XMLHttpRequest()
//   let vHtml = ''
//   xhr.open('get', file, true)
//   xhr.responseType = 'arraybuffer'
//   xhr.onload = () => {
//     if (xhr.status == 200) {
//       mammoth.convertToHtml({ arrayBuffer: new Uint8Array(xhr.response) }).then((resultObject) => {
//         vm.$nextTick(function () {
//           vHtml = resultObject.value
//           vm.$emit('isOpenDialog', vHtml)
//         })
//       })
//     }
//   }
//   xhr.send()
// }

export function setOptions (options, keyValue) {
  let opts = []
  options.forEach((item) => {
    if (!item.label) {
      item.label = item[keyValue.label]
    }
    if (!item.value) {
      item.value = item[keyValue.value]
    }
    opts.push(item)
  })
  return opts
}
export function debounce (func, delay = 300, immediate = false) {
  let timer = null
  return function () {
    if (timer) {
      clearTimeout(timer)
    }
    if (immediate && !timer) {
      func.apply(this, arguments)
    }
    timer = setTimeout(() => {
      func.apply(this, arguments)
    }, delay)
  }
}

/**
 *  数组查找摸一个字段的字符串拼接
 *  @author  ksy  2022.11.30
 *  type  arr  数组  Array
 *  isPositive  Boolean
 *  status  String filed  String 要查的属性key
 *  type  String filed  String 要查的属性key
 * */
export function getString (arr, filed, type) {
  let s = []
  if (arr && arr.length > 0) {
    arr.some((item) => {
      if (item && item[filed]) {
        s.push(item[filed])
      }
    })
  }
  return type ? s : s.toString()
}

export function copyToClip (content, that, tips) {
  if (navigator.clipboard && window.isSecureContext) {
    navigator.clipboard.writeText(content).then(
      // 复制成功callback
      function () {
        if (tips == null) {
          that.$message.success('复制成功！')
        } else {
          that.$message.success(tips)
        }
      },
      // 复制失败callback
      function () {
        that.$message.error('复制失败')
      }
    )
  }
}

/**
 * 千分符 且 保留两位小数
 *  @author ksy
 *  @createdTime 2023.1.13
 *  @lastModifiedTime 最后更改时间
 * */
export function ThousandAndDecimal (num) {
  if ((num || num == 0) && typeof Number(num) == 'number' && !isNaN(Number(num))) {
    num = Number(num).toFixed(2)
    num = num + '' //数字转字符串
    let str = '' //字符串累加
    //判断是否有负号
    let isMinus = num.indexOf('-') != -1
    if (isMinus) num = num.split('-')[1]
    // let result = num.indexOf('.') //判断是否有小数点
    // if (result != -1) {
    // console.log('含有小数');
    let sum = num.split('.') //sum[0]小数点前面部分;sum[1]为小数部分
    for (let i = sum[0].length - 1, j = 1; i >= 0; i--, j++) {
      // const isDivide = sum[0].indexOf('-') > -1 ? j % 4 == 0 : j % 3 == 0 //判断是否是负数，是则每隔四位加逗号
      const isDivide = j % 3 == 0
      if (isDivide && i != 0) {
        //每隔三位加逗号，过滤正好在第一个数字的情况
        str += sum[0][i] + ',' //加千分位逗号
        continue
      }
      str += sum[0][i] //倒着累加数字
    }
    return isMinus ? '-' + str.split('').reverse().join('') + '.' + sum[1] : str.split('').reverse().join('') + '.' + sum[1]
    // } else {
    //   // console.log('没有小数');
    //   for (let i = num.length - 1, j = 1; i >= 0; i--, j++) {
    //     // const isDivide = num.indexOf('-') > -1 ? j % 4 == 0 : j % 3 == 0 //判断是否是负数，是则每隔四位加逗号
    //     const isDivide = j % 3 == 0
    //     if (isDivide && i != 0) {
    //       //每隔三位加逗号，过滤正好在第一个数字的情况
    //       str += num[i] + ',' //加千分位逗号
    //       continue
    //     }
    //     str += num[i] //倒着累加数字
    //   }
    //   return str.split('').reverse().join('') //字符串=>数组=>反转=>字符串
    // }
  } else {
    return num
  }
}

// 两个Date对象相减获得的小时
export function dateCompute (s1, s2, date1, date2) {
  let newDate = {}
  let t1 = new Date(date1).getTime(),
    t2 = new Date(date2).getTime()

  let total = (t2 - t1) / 1000
  let day = Math.abs(parseInt(total / (24 * 60 * 60))) //计算整数天数

  let afterDay = Math.abs(total - day * 24 * 60 * 60) //取得算出天数后剩余的秒数

  let hour = Math.abs(parseInt(afterDay / (60 * 60))) //计算整数小时数

  let afterHour = Math.abs(total - day * 24 * 60 * 60 - hour * 60 * 60) //取得算出小时数后剩余的秒数

  let min = Math.abs(parseInt(afterHour / 60)) //计算整数分

  let afterMin = Math.abs(total - day * 24 * 60 * 60 - hour * 60 * 60 - min * 60) //取得算出分后剩余的秒数

  console.log('dateFormat.js~~~', { day, afterDay, hour, afterHour, min, afterMin })
  newDate = {
    day,
    afterDay,
    hour,
    afterHour,
    min,
    afterMin,
  }

  return newDate
}


// Date加小时
export function dateHourCompute (date, hour, emptyText) {
  if (!date) {
    return {
      y: emptyText,
      m: emptyText,
      d: emptyText
    }
  }
  let t1 = new Date(date).getTime()
  let t2 = hour * 60 * 60 * 1000
  let nDate = new Date(t1 + t2)
  const formatObj = {
    y: nDate.getFullYear(),
    m: nDate.getMonth() + 1,
    d: nDate.getDate()
  }
  return formatObj
}

/**
 *  数组分割--一维数组改为二位数组
 *  @author ksy
 *  @createdTime 2023.3.20
 *  @lastModifiedTime 最后更改时间
 * */
export function getNewArray (array, subGroupLength) {
  // array 代表一个数组
  // subGroupLength 代表数组里面的数组的length值
  let index = 0
  let newArray = []
  while (index < array.length) {
    newArray.push(array.slice(index, (index += subGroupLength)))
  }
  return newArray
}

/**
 *
 * @param {*} columnArr 合并行所在的列字段
 * @param {*} data 需要合并的表格数据
 * @returns
 */
export function colMethod (columnArr, data) {
  // columnArr 合并行所在的列字段
  // data 需要合并的表格数据
  let column = {}
  let position = 0
  // 遍历合并的列数据
  columnArr.forEach((prop) => {
    column[prop] = []
    //  遍历合并的行数据
    data.forEach((row, rowIndex) => {
      if (!row) return
      // 第N列第一行
      column[prop][rowIndex] = [1, 1]
      if (rowIndex === 0) {
        // 记录当前行号
        position = 0
      } else if (row[prop] === data[rowIndex - 1][prop]) {
        // 当前行数据等于上一行，根据记录的行号，计算需要合并几行。
        column[prop][position][0] += 1
        // 当前行 隐藏不显示
        column[prop][rowIndex][0] = 0
      } else {
        // 不相等之后，重置记录行号
        position = rowIndex
      }
    })
  })
  return column
}

/**
 *
 * @param {*} tableData 表格数据
 * @param {*} key 属性key
 * @param {*} rowIndex 行索引
 * @returns
 */
export function mergeComon (tableData, key, rowIndex) {
  // 合并单元格
  let keyName = tableData[rowIndex][key]
  if (rowIndex > 0) {
    // eslint-disable-next-line eqeqeq
    if (tableData[rowIndex][key] != tableData[rowIndex - 1][key]) {
      let i = rowIndex
      let num = 0
      while (i < tableData.length) {
        if (tableData[i][key] === keyName) {
          i++
          num++
        } else {
          i = tableData.length
        }
      }
      return {
        rowspan: num,
        colspan: 1,
      }
    } else {
      return {
        rowspan: 0,
        colspan: 1,
      }
    }
  } else {
    let i = rowIndex
    let num = 0
    while (i < tableData.length) {
      if (tableData[i][key] === keyName) {
        i++
        num++
      } else {
        i = tableData.length
      }
    }
    return {
      rowspan: num,
      colspan: 1,
    }
  }
}

// 去掉千分符
export function remoney (num) {
  num = num.replace(/,/gi, '')
  num = Number(num)
  return num
}

//去除括号里面的注释然后做计算
export function ellipsisXmlName (value) {
  let result = ''
  if (!value) return ''
  if (value.indexOf('【') >= 0 && value.indexOf('】') >= 0) {
    result = value.replace(/【[^\)]*】/g, '')
  } else if (value.indexOf('[') >= 0 && value.indexOf(']') >= 0) {
    result = value.replace(/\([^\)]*\)/g, '')
  } else {
    result = value
  }
  /**
   * ----------
   * */
  let arr = [] // 记录分割计算表达式
  for (let i = 0; i < result.length; i++) {
    let item = result.charAt(i)
    console.log(item, i, 'item-----')
    let num = item
    if (/[\d|\.]/.test(item)) {
      let j = i + 1
      for (j; j < result.length; j++) {
        let otherItem = result.charAt(j)
        if (!/[\d|\.]/.test(otherItem)) {
          break
        }
      }
      num = result.slice(i, j)
      i = j - 1
      num = +num
    }
    arr.push(num)
  }

  /**
   * ----------
   * */
  let charArr = [],
    numArr = []
  for (let i = 0; i < arr.length; i++) {
    if (typeof arr[i] == 'number') {
      numArr.push(arr[i])
    } else {
      if (charArr.length) {
        // 如果当前的运算符的优先级比栈顶的优先级低或相等，就说明需要把前面的值全部计算好
        // 存储运算符的栈要一直出栈，直到栈为空或当前的字符的优先级比栈顶的优先级高
        while (isPop(arr[i], charArr[charArr.length - 1])) {
          let t2 = numArr.pop()
          let t1 = numArr.pop()
          let char = charArr.pop()
          handleCalculation(numArr, t1, t2, char)
        }
        // 当前运算符为右括号
        if (arr[i] == ')') {
          // 取栈顶运算符
          let st = charArr[charArr.length - 1]
          // 步骤2
          // 遇到右括号也要一直出栈，直到遇到左括号
          while (st != '(') {
            let t1, t2
            let char = charArr.pop()
            if (char != '(') {
              t2 = numArr.pop()
              t1 = numArr.pop()
              handleCalculation(numArr, t1, t2, char)
            }
            st = char
          }
        }
        // 运算符不为右括号
        if (arr[i] != ')') {
          charArr.push(arr[i])
        }
      } else {
        // 步骤3
        // 运算符栈为空，直接入栈
        charArr.push(arr[i])
      }
    }
  }
  // 步骤4
  // 最后运算符栈如果还有字符，要一直出栈直到为空
  while (charArr.length) {
    let t2 = numArr.pop()
    let t1 = numArr.pop()
    let char = charArr.pop()
    handleCalculation(numArr, t1, t2, char)
  }
  console.log(numArr, '运算结果')
  return numArr[0]
}

export function handleCalculation (numArr, num1, num2, char) {
  if (char == '+') {
    numArr.push(num1 + num2)
  } else if (char == '-') {
    numArr.push(num1 - num2)
  } else if (char == '*') {
    numArr.push(num1 * num2)
  } else if (char == '/') {
    numArr.push(num1 / num2)
  }
}

export function isPop (char1, char2) {
  // 运算符栈为空
  if (!char2) {
    return false
  }
  // 运算符优先级相同
  if ((char1 == '+' || char1 == '-') && (char2 == '+' || char2 == '-')) {
    return true
  }
  // 前者运算符优先级比后者低
  if ((char1 == '+' || char1 == '-') && (char2 == '*' || char2 == '/')) {
    return true
  }
  // 运算符优先级相同
  if ((char1 == '*' || char1 == '/') && (char2 == '*' || char2 == '/')) {
    return true
  }
  // 前者运算符优先级比后者高
  if ((char1 == '*' || char1 == '/') && (char2 == '+' || char2 == '-')) {
    return false
  }
}

export function formatBankAccountNumber (accountNumber) {
  // 去除所有非数字字符
  let digits = accountNumber.replace(/\D/g, '')

  // 将字符串按照四位一组进行分割
  let formattedNumber = digits.match(/.{1,4}/g).join(' ')

  return formattedNumber
}
// 修改反选函数
export function contains (arr, filed, val) {
  for (var i = 0; i < arr.length; i++) {
    if (arr[i][filed] == val) {
      return false
    }
  }
  return true
}

/**
 * 数字转字母
 * @param {*} number 数字
 * @returns A,B,C,D,E,F,G...
 */
export function numberToLetter (number) {
  if (number < 1 || number > 26) {
    return 'Invalid number'
  }

  // 将数字转换为对应的字符编码
  var charCode = number + 64

  // 使用String.fromCharCode将字符编码转换为字母
  var letter = String.fromCharCode(charCode)

  return letter
}

/**
 * This is just a simple version of deep copy
 * Has a lot of edge cases bug
 * If you want to use a perfect deep copy, use lodash's _.cloneDeep
 * @param {Object} source
 * @returns {Object}
 */
export function deepClone (source) {
  if (!source && typeof source !== 'object') {
    throw new Error('error arguments', 'deepClone')
  }
  const targetObj = source.constructor === Array ? [] : {}
  Object.keys(source).forEach(keys => {
    if (source[keys] && typeof source[keys] === 'object') {
      targetObj[keys] = deepClone(source[keys])
    } else {
      targetObj[keys] = source[keys]
    }
  })
  return targetObj
}

// 合并行
export function mergeIndexRows (row, data, index, keys) {
  let keyObj = []
  // 判断 当前行的该列数据 与 上一行的该列数据 是否相等
  if (index !== 0) {
    for (let key of keys) {
      keyObj.push(row[key] === data[index - 1][key])
    }
    if (keyObj.every((item) => item)) {
      // 返回 0 使表格被跨 行 的那个单元格不会渲染
      return 0
    }
  }
  //     // 判断 当前行的该列数据 与 下一行的该列数据 是否相等
  let rowSpan = 1
  let rowSpanObj = []
  for (let i = index + 1; i < data.length; i++) {
    for (let key of keys) {
      rowSpanObj.push(row[key] !== data[i][key])
    }
    if (rowSpanObj.some((item) => item)) {
      break
    }
    rowSpan++
  }
  return rowSpan
}

 // 处理indexObj
export function dealMergeIndexObj (list) {
  let num = 0;
  let indexObj = {}
  list.forEach((item, index) => {
    if (item !== 0) {
      num++;
      indexObj[index] = num;
    }
  });
  return indexObj
}

// 自定义序号
export function customMergeIndex(list, index) {
  return list[index];
}

// 将给定字符串按照指定的间隔插入符号
export function toGapStr (val = '', gap = 4, description = ' ') {
  const regex = new RegExp('(\\w{' + gap + '})', 'g');
  const replacement  = "$1" + description;
  return val.replace(regex, replacement)
  // const v = val.toString()
  // return v.replace(/\s/g, '').split('').reduce((prev, cur, index) => {
  //   const gaps = index % gap === 0 && index !== 0 ? description : ''
  //   return prev + gaps + cur
  // }, '')
}

// 将给定字符串按照指定的匹配的字符串去重
export function toUniqueStr (val = '', description = '北京市|天津市|上海市|重庆市') {
  const regex = new RegExp('(' + description + ')\\1+', 'g');
  const replacement  = "$1";
  return val.replace(regex, replacement)
}